import { ErrorMessage } from 'formik';
import React, { Component } from 'react';
import UploadBrowseFile from '../../../../components/BrowseFile/uploadBrowseFile.component';
import Input from '../../../../components/Input/input.component';
import { numberMask } from '../../../../components/Input/Masks';
import Required from '../../../../components/Required/required.component';
import SelectMulti from '../../../../components/SelectMulti/selectmulti.component';
import estoqueService from '../../../../services/estoqueService';
import UploadService from '../../../../services/uploadService';
import { SaidaEventoValidationSchema, SaidaNaoEventoValidationSchema } from '../editarHistoricoDACA.modal.validates';

export default class ModalEditarHistoricoDacaSaida extends Component {
	/* Modal para edição da saida de bens de consumo */
	constructor(props) {
		super(props);
		this.state = {
			validationSchema: {},
			municipio: '',
			saldo: '',
			dataEvento: '',
			ocorrencias: [],
			estoques: [],
			files: [],
			termoRemovidoManualmente: false,
			idOrigemEstoqueSalvo: 0,
		};
	}

	async componentDidMount() {
		const { idDaca, transacao, handleValidationSchema } = this.props;
		const ocorrenciasResponse = await estoqueService.findAllOcorrencias();
		const estoquesResponse = await estoqueService.findByDacaId(idDaca);

		this.setState({ ocorrencias: [...ocorrenciasResponse.data] });
		this.setState({ estoques: [...estoquesResponse.data] });

		if (transacao.isEvento) {
			this.setState({
				validationSchema: SaidaEventoValidationSchema,
				termoRemovidoManualmente: true,
			});
		} else {
			this.setState({
				validationSchema: SaidaNaoEventoValidationSchema,
				files: [{
					source: 1,
					options: {
						type: 'limbo',
						file: {
							name: transacao.documento ? transacao.documento.nome : '',
							size: transacao.documento ? transacao.documento.size : 0,
						},
					},
				}],
			});
		}

		const { validationSchema } = this.state;
		handleValidationSchema(validationSchema);

		if (transacao.isEvento && transacao.ocorrencia) {
			const { ocorrencias } = this.state;
			const listItem = ocorrencias.find(x => x.id === transacao.ocorrencia.id);
			this.setState({
				dataEvento: listItem.data,
				municipio: listItem.municipio.nome,
			});
		}

		if (transacao.origemEstoque) {
			const { estoques } = this.state;
			const listItem = estoques.find(x => x.id === transacao.origemEstoque.id);

			this.setState({
				saldo:
				listItem.id === transacao.origemEstoque.id
					? transacao.quantidadeAnteriorOrigem
					: listItem.quantidade,
			});
			this.setState({
				idOrigemEstoqueSalvo: transacao.origemEstoque.id,
			});
		}
	}

	onChangeTipoOficio(event) {
		const { handleValidationSchema, transacao } = this.props;
		if (event.target.value === 'true') {
			handleValidationSchema(SaidaEventoValidationSchema);
		} else {
			handleValidationSchema(SaidaNaoEventoValidationSchema);
		}

		const newState = this.state;
		if (!newState.termoRemovidoManualmente) {
			newState.files = [{
				source: 1,
				options: {
					type: 'limbo',
					file: {
						name: transacao.documento ? transacao.documento.nome : '',
						size: transacao.documento ? transacao.documento.size : 0,
					},
				},
			}];
		}
		this.setState(newState);
	}

	handleRemoveFile = () => {
		this.setState(() => ({
			files: [],
			termoRemovidoManualmente: true,
		}));
	};

	handleChangeSelect = (id, listName) => {
		if (id === '') {
			if (listName === 'estoques') {
				this.setState({ saldo: '' });
			} else {
				this.setState({ municipio: '', dataEvento: '' });
			}
			return;
		}

		// eslint-disable-next-line
		const listItem = this.state[listName].find(x => x.id == id);
		if (listName === 'estoques') {
			const { transacao } = this.props;
			const { idOrigemEstoqueSalvo } = this.state;
			this.setState({
				saldo:
				listItem.id === idOrigemEstoqueSalvo
					? transacao.quantidadeAnteriorOrigem
					: listItem.quantidadeDisponivel,
			});
		} else {
			this.setState({
				municipio: listItem.municipio.nome,
				dataEvento: listItem.data,
			});
		}
	};

	/*
		Filtra estoques, para não receber nem ARP e nem Compra emergencial como estoques na saída
	*/
	filterEstoque() {
		const { estoques, idOrigemEstoqueSalvo } = this.state;
		const estoquesFiltrados = estoques.filter(estoque => (estoque.tipoEstoque !== 'ARP') && (estoque.tipoEstoque !== 'COMPRA_EMERGENCIAL') && (estoque.quantidadeDisponivel > 0 || estoque.id === idOrigemEstoqueSalvo));
		return estoquesFiltrados;
	}

	render() {
		const {
			state: {
				files,
				ocorrencias,
				municipio,
				dataEvento,
				saldo,
			},
			props: {
				handleChange,
				setFieldValue,
				transacao,
			},
		} = this;
		return (
			<React.Fragment>
				<div className='row'>
					<div className='col-12'>
						<p><strong>Item:</strong> {transacao.daca.nome}</p>
					</div>
					<div className='col-md-12'>
						<label>
							A retirada é para atender ocorrência? <Required />
						</label>
						<div className='form-group'>
							<div className='form-check form-check-inline'>
								<Input
									id='radio_1'
									name='isEvento'
									type='radio'
									className='form-check-input'
									onChange={(value) => {
										this.onChangeTipoOficio(value);
										setFieldValue('isEvento', true);
									}}
									checked={transacao.isEvento}
									value='true'
								/>
								<label
									htmlFor='radio_1'
									className='form-check-label pointer-text'
								>
									Sim
								</label>
							</div>
							<div className='form-check form-check-inline'>
								<Input
									id='radio_2'
									name='isEvento'
									type='radio'
									checked={!transacao.isEvento}
									className='form-check-input'
									onChange={(value) => {
										this.onChangeTipoOficio(value);
										setFieldValue('isEvento', false);
									}}
									value='false'
								/>
								<label
									htmlFor='radio_2'
									className='form-check-label pointer-text'
								>
									Não
								</label>
							</div>
						</div>
						<ErrorMessage
							name='isEvento'
							render={msg => (
								<span className='text-danger'>
									{msg}
								</span>
							)}
						/>
					</div>
				</div>

				{/* EVENTO */}
				{transacao.isEvento
						&& (
							<React.Fragment>
								<div className='row'>
									<div className='col-md-12'>
										<label>
											Ocorrência: <Required />
										</label>
										<div className='form-group'>
											<SelectMulti
												label='nome'
												name='ocorrencia.id'
												className='form-control form-control-sm'
												onChange={(e) => {
													this.handleChangeSelect(
														e.value,
														'ocorrencias',
													);
													handleChange(e.object);
													setFieldValue('ocorrencia.id', e.value);
												}}
												value={transacao.ocorrencia}
												options={ocorrencias}
											/>
											<ErrorMessage
												name='ocorrencia.id'
												render={msg => (
													<div className='mb-1 mt-0'>
														<span className='text-danger'>
															{' '}
															{msg}
														</span>
													</div>
												)}
											/>
										</div>
									</div>
								</div>
								<div className='row'>
									<div className='col-md-6'>
										<label>
											Município:
										</label>
										<div className='form-group'>
											{ municipio || '--'}
										</div>
									</div>

									<div className='col-md-6'>
										<label>
											Data do evento:
										</label>

										<div className='form-group'>
											{ dataEvento || '--'}
										</div>
									</div>
								</div>
							</React.Fragment>
						)
				}

				<React.Fragment>
					<div className='row'>
						<div className='col-md-6'>
							<label>
								Tipo de estoque: <Required />
							</label>

							<div className='form-group'>
								<SelectMulti
									label='nomeTipoEstoque'
									name='origemEstoque.id'
									className='form-control form-control-sm'
									onChange={(e) => {
										this.handleChangeSelect(
											e.value,
											'estoques',
										);
										handleChange(e.object);
										setFieldValue('origemEstoque.id', e.value);
									}
									}
									value={transacao.origemEstoque}
									options={this.filterEstoque()}
								/>
								<ErrorMessage
									name='origemEstoque.id'
									render={msg => (
										<div className='mb-1 mt-0'>
											<span className='text-danger'>
												{' '}
												{msg}
											</span>
										</div>
									)}
								/>
							</div>
						</div>

						<div className='col-md-6'>
							<label>
								Saldo:
							</label>

							<div className='form-group'>
								{saldo || '--'}
							</div>
						</div>
					</div>
					<div className='row'>
						<div className='col-md-6'>
							<label>
								Quantidade: <Required />
							</label>
							<div className='form-group'>
								<Input
									type='text'
									mask={numberMask}
									name='quantidadeEntradaSaida'
									value={transacao.quantidadeEntradaSaida}
									onChange={handleChange}
									maxLength={18}
								/>
								<ErrorMessage
									name='quantidadeEntradaSaida'
									render={msg => (
										<div className='mb-1 mt-0'>
											<span className='text-danger'>
												{' '}
												{msg}
											</span>
										</div>
									)}
								/>
							</div>
						</div>
					</div>
				</React.Fragment>

				{/* NÃO É EVENTO */}
				{!transacao.isEvento
						&& (
							<React.Fragment>
								<div className='row'>
									<div className='col-md-12'>
										<label>
											Motivo: <Required />
										</label>
									</div>
									<div className='container-fluid'>
										<Input
											name='motivo'
											type='textarea'
											value={transacao.motivo || ''}
											onChange={handleChange}
										/>
										<ErrorMessage
											name='motivo'
											render={msg => (
												<span className='text-danger'>
													{msg}
												</span>
											)}
										/>
									</div>
								</div>
								<div className='row'>
									<div className='col-md-12'>
										<label>
											Termo de recebimento: <Required />
										</label>
									</div>
									<div className='container'>
										<UploadBrowseFile
											name='documento'
											files={files}
											context={this}
											aspectRatio={0.1}
											valuesFormik={transacao}
											expetedTypesLabel='Selecione arquivos de texto ou imagens'
											onUpload={(documento) => {
												setFieldValue('documento', documento.data.data);
											}}
											handleUploadFile={UploadService.handleUploadFilePond}
											acceptedFileTypes={
												[
													'application/pdf',
													'application/msword',
													'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
													'image/png',
													'image/jpeg',
													'image/jpg',
													'image/bmp',
													'image/tiff',
												]
											}
											handleRemoveFile={() => {
												this.handleRemoveFile();
												setFieldValue('documento', null);
											}}
										/>
										<ErrorMessage
											name='documento'
											render={msg => (
												<span className='text-danger'>
													{msg}
												</span>
											)}
										/>
									</div>
								</div>
							</React.Fragment>
						)
				}
			</React.Fragment>
		);
	}
}
